window.__sapp = window.__sapp || {};
window.__sapp.handlers = window.__sapp.handlers || {};

(function (S) {

  /* ---- rule handlers ---- */

  /* Example: prevent default + stop propagation before replay
     S.handlers.beforeReplay = function (ev) {
       ev.preventDefault();
       ev.stopPropagation();
       //etc
     };
  */

  /* Example: react when a specific script has actually loaded
     S.handlers.afterReplay = function (node, rule) {
       console.log('replay ready', node.src);
     };
  */

  /* ---- custom logic ---- */

  /* DPO retry: include.js executes before ShopifyAnalytics sets window.meta,
      so dpoObserver.init() reads productId=0 and bails through dpo_no_options.
      Re-trigger loadOptions() once window.meta is ready. */
    (function dpoRetry(tries){
      if (tries > 60) return;
      if (!window.dpoObserver || !window.meta || !window.meta.product) {
        setTimeout(function(){ dpoRetry(tries + 1); }, 100);
        return;
      }
      if (!window.dpoObserver.productId) {
        window.dpoObserver.variantId = null;
        try { window.dpoObserver.loadOptions(); } catch (e) { console.warn('DPO retry failed', e); }
      }
    })(0);


  /* AB12 FAQ sticky injector.
     test-implementation.js races with the EasySlider extension rerender of
     .ProductMeta__Description .easyslider-contents. Depending on order, FAQ
     items either don't get injected or get wiped. We poll briefly to inject
     ourselves and re-inject if the wrapper is rebuilt. */
     
  function injectFaq() {
    var target = document.querySelector('.ProductMeta__Description .easyslider-contents');
    if (!target) return false;
    if (target.querySelector('.eg-minifaq')) return true;
    var scripts = document.querySelectorAll('[data-product-qa-block]');
    if (!scripts.length) return false;
    var items = [];
    for (var i = 0; i < scripts.length; i++) {
      try { items.push(JSON.parse(scripts[i].textContent)); } catch (e) {}
    }
    if (!items.length) return false;
    var baseId = 'es-qa-' + Date.now();
    var html = items.map(function (item, idx) {
      var id = baseId + '-' + idx;
      var question = (item.question || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var answer = item.answer || '';
      return '<div class="easyslider-item easyslider-item-static" data-es-marker="sapp-faq-' + idx + '" data-es-handle="slide-faq-' + idx + '">'
        + '<div class="easyslider-header" tabindex="0" aria-expanded="false" aria-labelledby="easyslider-label-' + id + '" aria-controls="easyslider-content-' + id + '" role="button">'
        + '<div class="easyslider-anchor"><span class="easyslider-header-text" id="easyslider-label-' + id + '">' + question + '</span><span class="easyslider-glyph"></span></div>'
        + '</div>'
        + '<div class="easyslider-content" id="easyslider-content-' + id + '" aria-hidden="true" aria-labelledby="easyslider-label-' + id + '" role="region">'
        + '<div class="easyslider-content-wrapper">' + answer + '</div>'
        + '</div></div>';
    }).join('') + '<div class="eg-minifaq"><p>FAQ</p></div>';
    target.insertAdjacentHTML('beforeend', html);
    document.body.classList.add('EG-NMNPPAB12');
    var minifaq = target.querySelector('.eg-minifaq');
    if (minifaq && !minifaq._faqHandlerBound) {
      minifaq._faqHandlerBound = true;
      minifaq.addEventListener('click', function (e) {
        e.preventDefault();
        var anchor = document.querySelector('#customers-ask');
        if (!anchor) return;
        var offset = window.innerWidth <= 768 ? 100 : 150;
        var top = anchor.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }
    return true;
  }

  function startFaqInjector() {
    /* EasySlider extension may rebuild .easyslider-contents wrapper from
       scratch (replacing the element, not its children) during its own init,
       so a one-shot inject + MutationObserver isn't sufficient. We poll
       every 300ms for 30s and reinject whenever FAQ is missing. */
    var startedAt = Date.now();
    var iv = setInterval(function () {
      injectFaq();
      if (Date.now() - startedAt > 30000) clearInterval(iv);
    }, 300);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    startFaqInjector();
  } else {
    document.addEventListener('DOMContentLoaded', startFaqInjector, { once: true });
  }


  /* AB11 mobile thumbnails pre-renderer.
     test-implementation.js builds .eg-thumbnails only after Flickity is
     available (10×500ms poll for window.Flickity) and after Flickity has
     wrapped slides in .flickity-slider. On slow connections this stays
     invisible until theme.js finishes booting. Render the strip from the
     raw server-rendered <img> as soon as DOM is parsed; click handlers
     pick up Flickity lazily and fall back to the original slide click. */
  function buildEgThumbnailsEarly() {
    if (window.innerWidth >= 767) return true;
    if (document.querySelector('.eg-thumbnails')) return true;
    var gallery = document.querySelector('.Product__Wrapper .Product__Gallery, .Product__Slideshow');
    if (!gallery) return false;
    var slideshow = gallery.matches('.Product__Slideshow') ? gallery : gallery.querySelector('.Product__Slideshow') || gallery;
    var imgs = slideshow.querySelectorAll('.Product__SlideshowSlide img, .Image--mediaWrapper img, img');
    var seen = {};
    var uniq = [];
    for (var i = 0; i < imgs.length; i++) {
      var raw = imgs[i].getAttribute('data-original-src') || imgs[i].getAttribute('data-src') || imgs[i].getAttribute('src') || '';
      if (!raw) continue;
      var key = raw.replace(/[?#].*$/, '');
      if (seen[key]) continue;
      seen[key] = 1;
      uniq.push(raw);
    }
    if (!uniq.length) return false;

    var wrap = document.createElement('div');
    wrap.className = 'eg-thumbnails';
    var container = document.createElement('div');
    container.className = 'eg-container';
    wrap.appendChild(container);

    uniq.forEach(function (src, index) {
      var href = src;
      if (href.indexOf('//') === 0) href = 'https:' + href;
      var thumb = document.createElement('div');
      thumb.className = 'eg-thumbnail' + (index === 0 ? ' active' : '');
      thumb.setAttribute('aria-label', 'Show image ' + (index + 1));
      thumb.innerHTML = '<img src="' + href + '" alt="Thumbnail ' + (index + 1) + '" loading="lazy" decoding="async">';
      thumb.addEventListener('click', function () {
        var flickityEl = slideshow.classList.contains('flickity-enabled') ? slideshow : slideshow.querySelector('.flickity-enabled');
        if (flickityEl && typeof window.Flickity !== 'undefined') {
          var flkty = window.Flickity.data(flickityEl);
          if (flkty) { flkty.select(index); return; }
        }
        var slides = slideshow.querySelectorAll('.Product__SlideshowSlide, .flickity-slider > *');
        if (slides[index]) slides[index].click();
      });
      container.appendChild(thumb);
    });

    slideshow.parentNode.insertBefore(wrap, slideshow.nextSibling);
    document.body.classList.add('EG-NMNPPAB11');
    return true;
  }

  function startEgThumbnailsEarly() {
    if (buildEgThumbnailsEarly()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (buildEgThumbnailsEarly() || ++tries > 40) clearInterval(iv);
    }, 50);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    startEgThumbnailsEarly();
  } else {
    document.addEventListener('DOMContentLoaded', startEgThumbnailsEarly, { once: true });
  }


  /* Autonomous drawer/popover toggler — works without theme.js and
     fully owns clicks on the matching buttons so theme.js's own
     delegate never reacts on the same event (stopImmediatePropagation
     in capture phase blocks both other capture listeners and the
     bubble phase). Only mutates aria-hidden + a few classes; visual
     animation comes from CSS.
     - open-drawer:   id == data-drawer-id
     - close-drawer:  id == data-drawer-id
     - close-popover: nearest .Popover ancestor */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var openBtn = t.closest('[data-action="open-drawer"][data-drawer-id]');
    if (openBtn) {
      var openId = openBtn.getAttribute('data-drawer-id');
      var openDrawer = openId && document.getElementById(openId);
      if (openDrawer) {
        openDrawer.setAttribute('aria-hidden', 'false');
        openDrawer.style.maxHeight = window.innerHeight + 'px';
        document.documentElement.classList.add('no-scroll');
        if (openBtn.hasAttribute('aria-expanded')) openBtn.setAttribute('aria-expanded', 'true');
        var overlayO = document.querySelector('.PageOverlay');
        if (overlayO) overlayO.classList.add('is-visible');

        /* AB28 fallback: Varify injects #ab28-drawer-root content
           async. On slow networks the drawer opens before Varify
           rendered → empty panel because ab28-hide CSS in
           __sapp-megamenu-placeholder.liquid kills the native menu.
           Show native menu temporarily; once Varify fills the root,
           remove the fallback class. */
        if (openId === 'sidebar-menu') {
          var ab28root = document.getElementById('ab28-drawer-root');
          if (!ab28root || !ab28root.firstElementChild) {
            document.body.classList.add('ab28-fallback');
            if (ab28root && !ab28root._sappObserved) {
              ab28root._sappObserved = true;
              var mo = new MutationObserver(function () {
                if (ab28root.firstElementChild) {
                  document.body.classList.remove('ab28-fallback');
                  mo.disconnect();
                }
              });
              mo.observe(ab28root, { childList: true });
            }
          }
        }
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var closeBtn = t.closest('[data-action="close-drawer"][data-drawer-id]');
    if (closeBtn) {
      var closeId = closeBtn.getAttribute('data-drawer-id');
      var closeDrawer = closeId && document.getElementById(closeId);
      if (closeDrawer) {
        closeDrawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        var overlayC = document.querySelector('.PageOverlay');
        if (overlayC) overlayC.classList.remove('is-visible');
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var popoverBtn = t.closest('[data-action="close-popover"]');
    if (popoverBtn) {
      var popover = popoverBtn.closest('.Popover');
      if (popover) {
        popover.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        var overlayP = document.querySelector('.PageOverlay');
        if (overlayP) overlayP.classList.remove('is-visible');
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* Sold-out variant marker.
     Independent re-implementation of theme.js's `linkOptionSelectors` +
     `updateOptionsInSelector` soldout logic. theme.js is now deferred and its
     copy does not reliably run on initial load (we saw 0 of ~22 unavailable
     years marked), so this fills the gap without depending on theme.js timing.
     It builds the option-availability map itself from the page's
     `[data-product-json]` script, so it does NOT read Shopify.optionsMap.
     It does not remove or replace theme.js's code: both derive availability
     from the same variant data and converge to the exact same set of
     `soldout_variant` items, so re-running either is idempotent and they do
     not fight. A guard prevents double-binding. Covers radio swatches
     (.HorizontalList__Item) and Popover dropdowns (.Popover__Value). */
  (function soldoutMarker() {

    if (S.__soldoutMarkerInit) return;
    S.__soldoutMarkerInit = true;

    var optionsMap = null;

    function uniq(arr) {
      var seen = {}, out = [];
      for (var i = 0; i < arr.length; i++) {
        var v = arr[i];
        if (!seen[v]) { seen[v] = 1; out.push(v); }
      }
      return out;
    }

    function buildMap() {
      var el = document.querySelector('[data-product-json]');
      if (!el) return null;
      var data;
      try { data = JSON.parse(el.textContent); } catch (e) { return null; }
      var product = data.product || data;
      if (!product || !product.variants) return null;
      var map = {};
      var optsLen = (product.options || []).length;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        map.root = map.root || [];
        map.root.push(v.option1);
        map.root = uniq(map.root);
        if (v.available) {
          if (optsLen > 1) {
            var k1 = v.option1;
            map[k1] = map[k1] || [];
            map[k1].push(v.option2);
            map[k1] = uniq(map[k1]);
          }
          if (optsLen === 3) {
            var k2 = v.option1 + ' / ' + v.option2;
            map[k2] = map[k2] || [];
            map[k2].push(v.option3);
            map[k2] = uniq(map[k2]);
          }
        }
      }
      return map;
    }

    function selectedValue(index) {
      var pop = document.querySelector(
        '.OptionSelector.Popover[data-option="' + index + '"] .Popover__Value.is-selected');
      if (pop) return pop.getAttribute('data-value');
      var radio = document.querySelector(
        '.ProductForm__Option[data-option="' + index + '"] input[type="radio"]:checked');
      return radio ? radio.value : null;
    }

    function itemValue(el) {
      var dv = el.getAttribute('data-value');
      if (dv != null && dv !== '') return dv;
      var input = el.querySelector('input');
      return input ? input.value : null;
    }

    function toggle(el, soldout) {
      if (soldout) {
        el.classList.add('soldout_variant');
        var i = el.querySelector('input');
        if (i) i.setAttribute('aria-label', 'sold out');
      } else {
        el.classList.remove('soldout_variant');
        var v = itemValue(el);
        var i2 = el.querySelector('input');
        if (i2 && v != null) i2.setAttribute('aria-label', v);
      }
    }

    function updateIndex(index) {
      if (!optionsMap) return;
      var key;
      if (index === 0) {
        key = 'root';
      } else if (index === 1) {
        key = selectedValue(0);
      } else {
        key = selectedValue(0) + ' / ' + selectedValue(1);
      }
      var available = optionsMap[key];
      if (!available) return;
      var items = document.querySelectorAll(
        '.ProductForm__Option[data-option="' + index + '"] .HorizontalList__Item,' +
        '.OptionSelector.Popover[data-option="' + index + '"] .Popover__Value');
      for (var i = 0; i < items.length; i++) {
        var v = itemValue(items[i]);
        toggle(items[i], available.indexOf(v) === -1);
      }
    }

    function updateAll() {
      var opts = document.querySelectorAll(
        '.ProductForm .ProductForm__Option--labelled,' +
        '.ProductForm .OptionSelector.Popover');
      // Index 0 (root) is always fully available; start at 1.
      for (var i = 1; i < opts.length; i++) updateIndex(i);
    }

    function bind() {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest &&
            e.target.closest('.ProductForm__Option input[type="radio"]')) {
          setTimeout(updateAll, 0);
        }
      }, true);
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest &&
            e.target.closest('.OptionSelector.Popover .Popover__Value')) {
          setTimeout(updateAll, 0);
        }
      }, true);
      // theme.js fires this once its component finally inits; recompute after
      // it so the final state stays correct regardless of who ran last.
      document.addEventListener('variant:changed', function () {
        setTimeout(updateAll, 0);
      }, true);
    }

    (function init(tries) {
      if (tries > 100) return;
      if (!optionsMap) optionsMap = buildMap();
      if (!optionsMap ||
          !document.querySelector('.ProductForm .ProductForm__Option--labelled,' +
                                  '.ProductForm .OptionSelector.Popover')) {
        setTimeout(function () { init(tries + 1); }, 100);
        return;
      }
      updateAll();
      bind();
    })(0);

  })();

})(window.__sapp);


/* loadjs */
loadjs=function(){var h=function(){},c={},u={},f={};function o(e,n){if(e){var r=f[e];if(u[e]=n,r)for(;r.length;)r[0](e,n),r.splice(0,1)}}function l(e,n){e.call&&(e={success:e}),n.length?(e.error||h)(n):(e.success||h)(e)}function d(r,t,s,i){var c,o,e=document,n=s.async,u=(s.numRetries||0)+1,f=s.before||h,l=r.replace(/[\?|#].*$/,""),a=r.replace(/^(css|img)!/,"");i=i||0,/(^css!|\.css$)/.test(l)?((o=e.createElement("link")).rel="stylesheet",o.href=a,(c="hideFocus"in o)&&o.relList&&(c=0,o.rel="preload",o.as="style")):/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(l)?(o=e.createElement("img")).src=a:((o=e.createElement("script")).src=r,o.async=void 0===n||n),!(o.onload=o.onerror=o.onbeforeload=function(e){var n=e.type[0];if(c)try{o.sheet.cssText.length||(n="e")}catch(e){18!=e.code&&(n="e")}if("e"==n){if((i+=1)<u)return d(r,t,s,i)}else if("preload"==o.rel&&"style"==o.as)return o.rel="stylesheet";t(r,n,e.defaultPrevented)})!==f(r,o)&&e.head.appendChild(o)}function r(e,n,r){var t,s;if(n&&n.trim&&(t=n),s=(t?r:n)||{},t){if(t in c)throw"LoadJS";c[t]=!0}function i(n,r){!function(e,t,n){var r,s,i=(e=e.push?e:[e]).length,c=i,o=[];for(r=function(e,n,r){if("e"==n&&o.push(e),"b"==n){if(!r)return;o.push(e)}--i||t(o)},s=0;s<c;s++)d(e[s],r,n)}(e,function(e){l(s,e),n&&l({success:n,error:r},e),o(t,e)},s)}if(s.returnPromise)return new Promise(i);i()}return r.ready=function(e,n){return function(e,r){e=e.push?e:[e];var n,t,s,i=[],c=e.length,o=c;for(n=function(e,n){n.length&&i.push(e),--o||r(i)};c--;)t=e[c],(s=u[t])?n(t,s):(f[t]=f[t]||[]).push(n)}(e,function(e){l(n,e)}),r},r.done=function(e){o(e,[])},r.reset=function(){c={},u={},f={}},r.isDefined=function(e){return e in c},r}();loadJS=loadjs;